<template>
    <div class="admin-module">
        <AdminLayoutComponent>
            <DataCharts
                :analytics-data="analyticsData"
                :is-loading="isLoading"
                :loading-more="isLoadingMore"
                :loaders="1"
                loader-type="table"
                @on-click-table-inner-data="onShowInnerChart($event)"
                @pagination-changed="onPaginationChanged($event)"
            />
        </AdminLayoutComponent>
    </div>
</template>

<script>
import { ref, computed } from "vue";
import AdminLayoutComponent from "@Layouts/admin/";
import DataCharts from "@DataChartsModule/module";
import useAnalytics from "@Functions/useAnalytics.js";

export default {
    name: "AdminModule",
    components: {
        AdminLayoutComponent,
        DataCharts,
    },
    setup() {
        const {
            adminAnalyticsData,
            aggregationTableData,
            isLoading,
            router,
            store,
            getAdminAnalytics,
            isLoadingMore,
        } = useAnalytics();

        const currentPage = ref(1);

        const onShowInnerChart = (data) => {
            const { slug, type, aggregation } = data;
            router.push({
                name: "aggregation-table",
                params: { aggregation: _.replace(aggregation, "_", "-"), type },
                query: { slug },
            });
        };

        const onPaginationChanged = (page) => {
            store.commit("Analytics/setAdminSaveParams", {
                page,
            });
            getAdminAnalytics();
        };

        const analyticsData = computed(() => {
            return router.currentRoute.value.name === "admin"
                ? adminAnalyticsData.value
                : aggregationTableData.value;
        });

        return {
            analyticsData,
            currentPage,
            isLoading,
            adminAnalyticsData,
            aggregationTableData,
            isLoadingMore,
            onShowInnerChart,
            onPaginationChanged,
        };
    },
};
</script>

<style lang="scss">
.admin-module {
    .spinner-component {
        @apply flex items-center justify-center;
        min-height: 67vh;
    }
}
.pagination_component {
    .__container {
        @apply flex items-center justify-center;
        .__box {
            height: 30px;
            width: 30px;
            @apply border rounded p-1 mx-1 text-center;
        }
    }
}
</style>